var _ellipse, _ellipse2, _path, _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 145,
    rx: 36,
    ry: 12,
    fill: "#DADCE0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 55,
    rx: 48,
    ry: 12,
    fill: "#9AA0A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.108 55.813L64 145c0 6.627 16.118 12 36 12s36-5.373 36-12l11.892-89.187C146.22 62.06 125.417 67 100 67s-46.22-4.939-47.892-11.187z",
    fill: "#DADCE0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 55,
    width: 96,
    height: 102
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.108 55.813L64 145c0 6.627 16.118 12 36 12s36-5.373 36-12l11.892-89.187C146.22 62.06 125.417 67 100 67s-46.22-4.939-47.892-11.187z",
    fill: "#5F6368"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    stroke: "#fff",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.773 109.396L99.293 215.462M3.834 98.79L109.9 204.856M14.44 88.183l106.066 106.066M25.047 77.577l106.066 106.066M35.653 66.97l106.066 106.066M46.26 56.363l106.066 106.066M56.867 45.757l106.066 106.066M67.473 35.15l106.066 106.066M78.08 24.544L184.146 130.61M88.686 13.937l106.066 106.066M99.293 3.33l106.066 106.066M99.293 4.038L-6.773 110.104M109.9 14.644L3.834 120.71M120.506 25.251L14.44 131.317M131.113 35.857L25.047 141.923M141.719 46.464L35.653 152.53M152.326 57.071L46.26 163.137M162.933 67.677L56.867 173.743M173.539 78.284L67.473 184.35M184.146 88.89L78.08 194.956M194.752 99.497L88.686 205.563M205.359 110.104L99.293 216.17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-45 128.917 63.478)",
    d: "M0 0h151.5v151.5H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTrash);
export default __webpack_public_path__ + "static/media/empty-trash.6850fea8766f4f1476c43fdd80cc4655.svg";
export { ForwardRef as ReactComponent };